import { PricingMainType } from '@lib/sanity/queries/modules/pricingMain/types';
import PlanCardsDesktop from './PlanCardsDesktop';
import PlanCardsMobile from './PlanCardsMobile';

type Props = {
  data: PricingMainType;
};

const PlanCardsModule = ({ data }: Props) => {
  return (
    <>
      <PlanCardsDesktop data={data.cardsPricing} />
      <PlanCardsMobile data={data.cardsPricing} />
    </>
  );
};

export default PlanCardsModule;
